import * as S from './styled'
import { IMaskInput } from 'react-imask';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
/**
 * Components
*/
import LayoutModal from '../../../LayoutModal'
import { useEffect } from 'react';
import Loading from "../../../../components/Loading";
/**
 * hooks 
*/
import { apiUpdate } from '../../../../hooks/apiUpdate';
import useLoading from "../../../../hooks/useLoading";
/**
 * Interfaces
*/
import { Inputs } from 'Interfaces/ISupllier';

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({ isOpenModal, setModalClose, updateList, selectedUrlId }: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const { handleSubmit } = apiUpdate(`supplier/${selectedUrlId}`);

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const response = await axiosInstance.get(`supplier/${selectedUrlId}`);
        const addressData = response.data;
        for (const key in addressData) {
          setValue(key as keyof Inputs, addressData[key]);
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);


  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const formattedData = {
        ...data,
        name: data.name.toUpperCase(), // Aqui você força caixa alta
      };

      const response = await handleSubmit(formattedData);
      if (response === 200) {
        alert("Fornecedor atualizado com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Fornecedor"
        subTitle="Atualize informações do fornecedor em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Fornecedor'}
      >
        {
          isLoading ? (
            <Loading />
          ) :
            <S.Container>
              <S.FormInput>
                <S.Label>
                  Nome do Fornecedor
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o fornecedor"
                  type="text"
                  {...register("name", { required: true })}
                />
                {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Contato</S.Label>
                <Controller
                  name="contact"
                  control={control}
                  render={({ field }) => (
                    <IMaskInput
                      className="imask"
                      id="phone_primary"
                      mask="(00) 00000-0000"
                      placeholder="(99) 99999-9999"
                      {...field}
                    />
                  )}
                />
              </S.FormInput>

              <S.FormInput>
                <S.Label>E-mail</S.Label>
                <S.Input
                  placeholder="exemplo@gmail.com"
                  type="email"
                  {...register("email")}
                />
              </S.FormInput>

              <S.FormInput>
                <S.Label>Descrição</S.Label>
                <S.TextArea
                  placeholder="Campo Opcional"
                  rows={2}
                  {...register("description")}
                />
              </S.FormInput>
            </S.Container>
        }

      </LayoutModal>
    );
  }
  return null;
}